import React from 'react';
import { Dimensions } from 'react-native';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { useCompany } from '@webtrader/core/services/company';

import Text from '@/components/Text';
import { openInAppBrowser } from '@/utils/web';

const HORIZONTAL_PADDINGS = dynamicSize.convertSize(32);
const CHECKBOX_WIDTH = dynamicSize.convertSize(30);

const SignUpFormAcknowledgement = () => {
  const { company } = useCompany();

  const tncUrl = company?.webtraderMemberTncUrl;
  const policyUrl = company?.webtraderMemberPolicyUrl;
  const riskDisclosureUrl = company?.webtraderMemberRiskDisclosureUrl;
  const { t } = useTranslation();

  return (
    <AcknowledgementContainer>
      <StyledText>
        {t("I confirm that I've read, understood and agree with")}{' '}
        <StyledLink onPress={() => openInAppBrowser(tncUrl)} testID={EDataTestId.SIGN_UP_PRIVACY_POLICY}>
          {t('Terms and Conditions')},{' '}
        </StyledLink>
        <StyledLink onPress={() => openInAppBrowser(policyUrl)} testID={EDataTestId.SIGN_UP_PRIVACY_POLICY}>
          {t('Privacy Policy')}{' '}
        </StyledLink>
        {t('and')}{' '}
        <StyledLink onPress={() => openInAppBrowser(riskDisclosureUrl)} testID={EDataTestId.SIGN_UP_RISK_DISCLOSURE}>
          Risk Disclosure Document
        </StyledLink>
        .
      </StyledText>
    </AcknowledgementContainer>
  );
};

export default SignUpFormAcknowledgement;

const AcknowledgementContainer = styled.View`
  width: ${Dimensions.get('window').width - HORIZONTAL_PADDINGS - CHECKBOX_WIDTH}px;
  flex-direction: row;
  align-items: flex-start;
`;

const StyledText = styled(Text)`
  font-size: ${dynamicSize.convertSize(12)}px;
  color: ${({ theme }) => theme.colors.text[1]};
`;

const StyledLink = styled(StyledText)`
  font-weight: 500;
  text-decoration-line: underline;
`;
